import script from "./SALSelectorPeriodo.vue?vue&type=script&setup=true&lang=js"
export * from "./SALSelectorPeriodo.vue?vue&type=script&setup=true&lang=js"

import "./SALSelectorPeriodo.vue?vue&type=style&index=0&id=b75b6292&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75b6292"]])

export default __exports__